const globalMixin = {

  data() {
    return {
      next_redirects: JSON.parse(sessionStorage.getItem('next_redirects')) || {}
    }
  },
  computed: {
    updateNextRedirectStore() {
      sessionStorage.setItem('next_redirects', JSON.stringify(this.next_redirects));
    },
    setNextRedirect(key, to) {
      this.next_redirects[key] = to;
      this.updateNextRedirectStore();
    },
    nextRedirect(key) {
      const to = this.next_redirects[key];
      if (to) {
        delete this.next_redirects[key];
        this.updateNextRedirectStore();
        return this.$router.push(to);
      }
      return false;
    },
    isApp(){ 
      return (!this.isNull(window.cordova) && window.cordova != false); // true
    },
    isIOS(){
      // return true;
      return (this.isApp && this.getMobileOperatingSystem() == 'iOS');
      //return false;
    },
    user_type(){
      if (this.get_me())
      {
        if(this.get_me().type == 'entrepreneur') return 'entrepreneur';
        if(this.get_me().type == 'lawyer') return 'lawyer';
        else return false;
      }
      else return false;
    },
    mainPageLink() {
      if (this.get_me()) {
        if (this.get_me().type == 'entrepreneur') return '/list';
        if (this.get_me().type == 'lawyer') return '/projects_manager';
      } else {
        return '/';
      }
    }
  },
  methods: {
        findClauseById(idOrFunc, parts=[], returnSet=false) {
          for (let z = 0; z < parts.length; z++) {
              const part = parts[z];
              if (part.clauses && part.clauses.length) { // Check if clauses exist
                for (let i = 0; i < part.clauses.length; i++) {
                  if(typeof idOrFunc === 'function')
                  {
                    if (idOrFunc(part.clauses[i])) {
                        if (returnSet) return (newClause) => { part.clauses[i] = newClause; return newClause; }
                        return part.clauses[i];
                    }
                  }
                  else
                  {
                    if (part.clauses[i].id == idOrFunc) {
                        if (returnSet) return (newClause) => { part.clauses[i] = newClause; return newClause; }
                        return part.clauses[i];
                    }
                  }
                }
              }
              
              if (part.parts && part.parts.length) {
                  const foundInSubPart = this.findClauseById(idOrFunc, part.parts, returnSet);
                  if (foundInSubPart) {
                      return foundInSubPart; // If found in a sub-part, return it
                  }
                  // If not found in this sub-tree, the loop for 'z' will continue to the next part.
              }
          }
          
          return null; // Not found in any part or sub-part
      },
      debounce(func, wait = 300) {
        let timeout;
        return function(...args) { 
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                func.apply(this, args);
            }, wait);
        };
    },
    checkPerms(){
      if (!this.user_type) return false;
      if (this.user_type == 'entrepreneur') return 'entrepreneur';
      if (this.user_type == 'lawyer') return 'lawyer';
    },
    applyCordova(func){
      if (this.isApp)
      {
        if (window.deviceReadyFired) func();
        else
        {
          document.addEventListener('deviceready', func);
        }
      }
    },
    preventScroll() {
      document.body.classList.add('no-scroll');
    },
    finishPreventScroll() {
      document.body.classList.remove('no-scroll');
    },
    getMobileOperatingSystem() {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  
      // Windows Phone must come first because its UA also contains "Android"
      if (/windows phone/i.test(userAgent)) {
          return "Windows Phone";
      }
  
      if (/android/i.test(userAgent)) {
          return "Android";
      }
      // Enhanced iOS detection logic
      if (/iPad|iPhone|iPod/.test(userAgent) || 
          (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
          return "iOS";
      }
            // macOS detection
        if (/Macintosh/.test(userAgent)) {
          return "iOS";
      }
  
      return "unknown";
  },
    
    requireLogin() {
      if (!this.get_me()) {
        this.alert('בכדי לבצע פעולה זו יש להתחבר לאפליקציה');
        return false;
      }
      return true;
    },
  share(url, message = 'מתכון שאהבתי'){
    if (this.isApp)
    {
      var options = {
        url: url,
        message: message,
      };
      var onSuccess = function() { };
      var onError = function() { };
      window.plugins.socialsharing.shareWithOptions(options, onSuccess, onError);
    }
    else
    {
      this.$bus.$emit('share_url', url);
      this.$bus.$emit('close_edit');
    }
  },

  browser(url){
    if (this.isApp)
    {
      window.openBrowser(url, '_system');
    }
    else 
    {
      window.open(url, '_blank');
    }
    
  },
  
  alert(msg){

      this.$swal({ html: msg, confirmButtonText: 'אוקי'});
    },

    confirm(title, confirm, cancel) {
      return new Promise((resolve) => {
        let sttings = {
            title: title,
            // showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: confirm,
            // denyButtonText: cancel
        }
        // if (confirm) {
        //   sttings['confirmButtonText'] = confirm
        // } 
        if (cancel) {
          sttings['showDenyButton'] = true
          sttings['denyButtonText'] = cancel
        } 
        this.$swal(sttings).then((result) => {
            if (result.isConfirmed) {
                resolve(true);
            } else {
                resolve(false);
            }
        });
      });
  },
  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  },
  filtereParts(parts, filterType = null, parentNumber = '', isChaild=false) {
    let index = 0;
    const res = parts.filter((part) => {
      let is_show = !part?.delete;
      if (filterType) {
        is_show = part.type === filterType;
      }
      if (is_show) {
        // Generate hierarchical number for the part
        let partNumber = '';
        if (isChaild) {
          partNumber = parentNumber ? `${parentNumber ? parentNumber + '.' : ''}${index + 1}` : `${index + 1}`;
        } else {
          partNumber = this.numToHebrew(index+1)
        }
        part.hierarchicalNumber = partNumber;

        // Process child parts
        if (part.parts.length) {
          part.parts = this.filtereParts(part.parts, null, (isChaild ? partNumber : ''), true);
        }

        if (part.clauses && part.clauses.length) {
          part.clauses.forEach((clause, clauseIndex) => {
            clause.hierarchicalNumber = `${!isNaN(partNumber[0]) ? partNumber + '.' : ''}${((part?.parts?.length ?? 0) + clauseIndex) + 1}`;
          });
        }
        index++
      }
      return is_show;
    })

    return res;
  },
 
    toast(msg, icon ='success', customClass = 'my_toast') {

      if (this.isApp)
      {
        window.plugins.toast.showShortTop(msg);
      }
      else
      {
        return this.$swal.fire({
          icon,
          text: msg,
          toast: true,
          position: 'bottom-start',
          showConfirmButton: false,
          customClass:{
            container: customClass
          },
          timer: 3000 
        });
      }
    },
    superToast(ico,msg,ask=false, timer=5000, showTimer=true){
			return new Promise((resolve, reject) => {
				this.$swal.fire({
					toast: true,
					html: msg,
					target: '#page',
					customClass: {
						container: 'toast-custom2'
					},
					timer: timer,
					timerProgressBar: showTimer,
					showConfirmButton: false,
					showCancelButton: ask,
					cancelButtonText: 'לבטל?',
					icon: ico ? 'success' : 'error',
					didOpen: (toast) => {
						toast.addEventListener('mouseenter', this.$swal.stopTimer)
						toast.addEventListener('mouseleave', this.$swal.resumeTimer)
					},
				}).then((res) => {
					if (res.dismiss == 'cancel') reject()
					else resolve()
				})
			});
		},

    bg(pic){
      return 'background-image:url(' + pic + ')';
    },
    get_word(key, strip=false){
      const word = this.$store.words[key];
      if (strip) {
        return this.removeHtml(word);
      }
      return word;
    },
    removeHtml(html){
      return (typeof html == 'string' ? html : '').replace(/<\/?[^>]+(>|$)/g, "");
    },

    get_unit_type_name(key){
      if (key > 0)
      {
        return this.$store.unit_types[key].name;
      }
      else return '';
    },
    
    save_item_to_store(item){
      
      if (this.isNull(item)) return;
      
      switch (item.type)
      {
        case 'video': this.$store.state.videos[item.id] = item; break;
        case 'article': this.$store.state.articles[item.id] = item; break;
        case 'faq': this.$store.state.faq[item.id] = item; break;
      }
    },
    format_number(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    toFixedIfNecessary( value, dp ){
      return +parseFloat(value).toFixed( dp );
    },
    
    isNull: function (str)
    {
      return (str == '' || str == null || str == undefined);
    },

    parse_date(str){
      var d=new Date(str); return d.getDate() + '/' + (d.getMonth() + 1) + '/' + d.getFullYear();
    },
    
    get_me(){
      return this.$store.user;
    },

    is_subscribed(){
      return (this.get_me() && this.get_me().is_subscribed);
    },

    setCookie(name, value, hours) {
      var expires = "";
      if (hours) {
          var date = new Date();
          date.setTime(date.getTime() + (hours * 60 * 60 * 1000));
          expires = "; expires=" + date.toUTCString();
      }
      var domain = document.location.hostname;
      // if (domain.includes('www.')) {
      //     domain = domain.replace('www.', '');
      // }
      document.cookie = name + "=" + (value || "") + expires + "; domain=." + domain + "; path=/";
    },
    unsetCookie(name) {
      var domain = document.location.hostname;
      // if (domain.includes('www.')) {
      //     domain = domain.replace('www.', '');
      // }
      document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; domain=." + domain + "; path=/";
    },
    getCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');
  
      for (var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) === ' ') {
              c = c.substring(1, c.length);
          }
          if (c.indexOf(nameEQ) === 0) {
              return c.substring(nameEQ.length, c.length);
          }
      }
  
      return null; // Return null if the cookie is not found
    },
    isCookieSet(name) {
      var cookies = document.cookie.split(';');
      for (var i = 0; i < cookies.length; i++) {
          var cookie = cookies[i].trim();
          var cookiePair = cookie.split('=');
          if (cookiePair[0] === name && cookiePair.length > 1) {
              return true;
          }
      }
      return false;
    },
  


    set_user_token(str)
    {
      localStorage.setItem('user_token',str);
    },
    
    logout(){
      localStorage.removeItem('user_token');
      
      this.$bus.$emit('reload');
      //document.location = '/';
    },
    
    get_item(action, type, id){

      var promise = new Promise((resolve/*, reject*/) => {

        if (this.$store.state[type][id] != null)
        {
          resolve(this.$store.state[type][this.id]);
        }
        else
        {
          this.api({action: action, data: { id: id }, method:'get'}, (data) => {

            this.save_item_to_store(data.data)

            resolve(data.data);
          });
        }

      });
      return promise;
    },

    uniqueId() {
      // return Math.random().toString(36).substr(2, 9)
      return Date.now();
    },

    range(start, end) {
      return Array.from({ length: end - start }, (_, i) => start + i);
    },

    api(settings, func=null, failFunc){
  
      if (this.isNull(func)) {
        return new Promise((resolve, reject) => {
          this.api(settings, resolve, reject);
        });
      }
  
       var headers = {
         'Content-Type': 'application/json; charset=utf-8',
       };
      
       if(!this.isNull(localStorage.getItem('user_token'))) 
       { 
         headers.Authorization = localStorage.getItem('user_token');
       }
     
  //         var requestOBJ;
       const cancelTokenSource = this.axios.CancelToken.source();

  
         if (settings.method == 'get')
         {
            let actionGet = settings.action;
            actionGet = actionGet + (actionGet.indexOf('?') === -1 ? '?' : '&');
            actionGet = actionGet + 'ts='  + (new Date()).getHours() + '_' + ((new Date()).getMinutes() < 30 ? '0' : '30');

            if (!this.isNull(settings.data))
            { 
            for (let i in settings.data) actionGet += '&' + i + '=' + settings.data[i];
            }

             this.axios.get(window.api_url + actionGet, { headers: headers, cancelToken: cancelTokenSource.token } ).then(response => {
              if (response.data == 'error')
              {
                this.set_user_token('');
                document.location.reload();
              }

              func(response.data);
           }, response => { 
             if (!this.isNull(failFunc)) failFunc(response);
             else func(false);
           });
      

// Cancel request
//cancelTokenSource.cancel();

         }
         else
         {
          this.axios.post(window.api_url + settings.action, settings.data, { headers: headers, cancelToken: cancelTokenSource.token })
          .then(response => {
            if (response.data == 'error')
            {
              this.set_user_token('');
              document.location.reload();
            }
               func(response.data);
               //console.log(response.body);
           }, response => { 
             if (!this.isNull(failFunc)) failFunc(response);
             //else func(false);
               //console.error(response.body);
           });
       }
       
      return cancelTokenSource;
  
     },

     numToHebrew(num) {
        // Define the mapping of numbers to Hebrew letters
        const hebrewLetters = {
            1: 'א', 2: 'ב', 3: 'ג', 4: 'ד', 5: 'ה', 6: 'ו', 7: 'ז', 8: 'ח', 9: 'ט',
            10: 'י', 20: 'כ', 30: 'ל', 40: 'מ', 50: 'נ', 60: 'ס', 70: 'ע', 80: 'פ', 90: 'צ',
            100: 'ק', 200: 'ר', 300: 'ש', 400: 'ת'
        };
    
        if (num <= 0) {
            return '';
        }
    
        let result = '';
    
        // Loop through the keys in descending order
        const values = Object.keys(hebrewLetters).map(Number).sort((a, b) => b - a);
        for (let value of values) {
            while (num >= value) {
                result += hebrewLetters[value];
                num -= value;
            }
        }
    
        return result;
    },

    is_mobile(){ 
      const toMatch = [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i
      ];
  
      return toMatch.some((toMatchItem) => {
          return navigator.userAgent.match(toMatchItem);
      });
    },

    decimalToFraction(decimal) {
      if (decimal % 1 === 0) {
        // If the number is a whole number, return it as is
        return decimal.toString();
      }

      const wholePart = Math.floor(decimal);
      let fractionPart = decimal - wholePart;

      // handle numbers like this 5.000000000000001
      if (decimal.toFixed(2) == parseInt(decimal)) return parseInt(decimal)


      // The precision for the fractional part
      const tolerance = 1.0E-6;
      let numerator = 1;
      let denominator = 1;

      // Find the closest fraction
      while (Math.abs(fractionPart - (numerator / denominator)) > tolerance) {
          if (fractionPart > (numerator / denominator)) {
              numerator++;
          } else {
              denominator++;
              numerator = Math.round(fractionPart * denominator);
          }
      }

      let fractionHtml = "";
      if (wholePart > 0) {
          fractionHtml += wholePart + '';
      }
      
      if (denominator < 10) {
          // Use HTML entity if it's a common fraction
          fractionHtml += `&frac${numerator}${denominator};`;
      } else {
        return this.toFixedIfNecessary(decimal,2);
          // Use fraction slash for other fractions
          // fractionHtml += `${numerator}&frasl;${denominator}`;
          
      }
      return fractionHtml;
    }


}
}

export default globalMixin